const MuiMultiInputDateRangeField = {
  defaultProps: {
    dateSeparator: " "
  }
};
export {
  MuiMultiInputDateRangeField
};
//# sourceMappingURL=MuiMultiInputDateRangeField.js.map
